<template>
  <div class="layout-wrapper layout-1 layout-fixed layout-navbar-fixed">
    <div class="layout-inner">
      <app-layout-navbar />

      <div class="layout-container">
        <app-layout-sidenav />

        <div class="layout-content">
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view />
          </div>
          <app-layout-footer />
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .layout-content{
    padding-top: 64px;
  }
</style>
<script>
import LayoutNavbar from './../components/LayoutNavbar';
import LayoutSidenav from './../components/LayoutSidenav';
import LayoutFooter from './../components/LayoutFooter';

export default {
  name: 'app-layout-1',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter,
  },

  mounted() {},

  beforeDestroy() {},

  methods: {},
};
</script>
